import { Fragment, useEffect, useState } from 'react';
import SourceButtonGroup from './SourceButtonGroup';

import { getSourceList } from '../../helpers/sourceListHelpers';
import { searchContext } from '../../../../../Context/Context.jsx';
import { SearchContext } from '../../../../../types';

export default function RenderSourcesLogic({ isScoreSource = false }) {
  const { tab, restrictSources, source } = searchContext() as unknown as SearchContext;
  const [sourceList, setSourceList] = useState(getSourceList({ tab, restrictSources }));

  useEffect(() => {
    const validSourceList = getSourceList({ tab, restrictSources });
    setSourceList(validSourceList);
  }, [tab, restrictSources, source]);

  const renderButtonsByCategory = sourceListObj => {
    return Object.keys(sourceListObj).map(category => (
      <div key={category} className="my-3">
        <div className="text-blue font-semibold text-sm ml-2">{category}</div>
        <SourceButtonGroup
          sourceList={sourceListObj[category]}
          category={category}
          isScoreSource={isScoreSource}
        />
      </div>
    ));
  };

  return (
    <Fragment>
      {Array.isArray(sourceList) ? (
        <SourceButtonGroup sourceList={sourceList} isScoreSource={isScoreSource} />
      ) : (
        <div>{renderButtonsByCategory(sourceList)}</div>
      )}
    </Fragment>
  );
}
